import React, { useState, useEffect} from "react";
import Wrapper from "../../components/Wrapper";
import InnerNav from "../../components/InnerNav";
import { FiSave } from "react-icons/fi";
import axios from 'axios';
import { Navigate } from "react-router-dom";
import ImageUpload from "../../components/imageUpload.js";



const SenderidCreate = ()=>{
     const [client, setClient ] = useState([]);
     const [clientId, setClientId] = useState('');
     const [name, setName ] = useState(''); 
     const [senderType, setSenderType ] = useState([]);
     const [senderTypeId, setSenderTypeId] = useState('');
     const [page, setPage] = useState(1);
     const [redirect, setRedirect] = useState(false);

     useEffect(() => {
        (
        async () => {

            const {data} = await axios.get(`client?page=${page}`);
            setClient(data.data); 

        }
        )();
    },[page]);


    useEffect(() => {
        (
        async () => {

            const {data} = await axios.get(`senderType?page=${page}`);
            setSenderType(data.data); 
            console.log(data);

        }
        )();
    },[page]);


     const submit = async (e)=>{
         e.preventDefault();
         const {data} = await axios.post('senderId', {
            client_id:parseInt(clientId),
            name,
            sender_type_id: parseInt(senderTypeId),
        });
        console.log(data);
        setRedirect(true);
     }
    if(redirect){
        return <Navigate to={'/senderid'} />
    }
     return (
         <Wrapper pageTitle={"New Senderid"}>
            <InnerNav createLink={'/senderidCreate'} listLink={'/senderid'} />
             <form onSubmit={submit}>
                <div className="px-4 py-3 mb-8 bg-white rounded-lg shadow-md dark:bg-gray-800" >
                <label className="block text-sm">
                    <span className="text-gray-700 dark:text-gray-400">Client </span>
                    <select
                        className="block w-full p-2 border mt-1 text-sm border-gray-300 rounded-md h-10 focus:border-purple-400 focus:outline-none focus:shadow-outline-purple dark:text-gray-300 form-input "
                        placeholder="senderId"
                        onChange = {e => setClientId(e.target.value)} >
                            <option key='0' value='0' >Choose Client</option>

                        {client.map((client)=>{
                                        return(
                                            <option key={client.id} value={client.id} >
                                            {client.name}
                                            </option>
                                        );
                                    })
                                }

                    </select>
                </label>

                    <label className="block text-sm">
                        <span className="text-gray-700 dark:text-gray-400">Name </span>
                        <input
                        className="block w-full p-2 border mt-1 text-sm border-gray-300 rounded-md h-10 focus:border-purple-400 focus:outline-none focus:shadow-outline-purple dark:text-gray-300 form-input "
                        placeholder="Name"
                        onChange = {e => setName(e.target.value)} />
                    </label>

                <label className="block text-sm">
                    <span className="text-gray-700 dark:text-gray-400">Sender Type </span>
                    <select
                        className="block w-full p-2 border mt-1 text-sm border-gray-300 rounded-md h-10 focus:border-purple-400 focus:outline-none focus:shadow-outline-purple dark:text-gray-300 form-input "
                        placeholder="senderId"
                        onChange = {e => setSenderTypeId(e.target.value)} >
                            <option key='0' value='0' >Choose Sender Type</option>

                        {senderType.map((senderType)=>{
                                        return(
                                            <option key={senderType.id} value={senderType.id} >
                                            {senderType.sender_type}
                                            </option>
                                        );
                                    })
                                }

                    </select>
                </label>

                    <div className="flex mt-6 text-sm">
                        <label className="flex items-center dark:text-gray-400">
                        <button className="flex items-center justify-between px-4 py-2 text-sm font-medium leading-5 text-white transition-colors duration-150 bg-blue-600 border border-transparent rounded-lg active:bg-white hover:bg-blue-400 focus:outline-none focus:shadow-outline-purple"
                        onClick={submit}
                        > <FiSave /> <span className="ml-3">Save</span> </button>
                        </label>
                    </div>
                </div>
             </form>
        </Wrapper>
     );
};
export default SenderidCreate;